module.exports = __webpack_public_path__ + "img/pointE_bg.837d47ba.png";